import SidePanel from 'libs/sidepanel/SidePanel'
import { useEffect, useState } from 'react'
import QuickAddEditWork from './QuickAddEditWo'

const QuickAddEditWorkOrder = ({
  id,
  isOpen,
  onClose,
  manufactureOrderFormik,
  data,
}: any) => {
  const [value, setValue] = useState(null)

  useEffect(() => {
    if (isOpen) {
      setValue(id)
    }
  }, [id, isOpen])

  const handleClose = () => {
    onClose(false)
    setValue(null)
  }

  return (
    <SidePanel
      size="large"
      isOpen={isOpen}
      title={value ? 'Quick Edit Work Order' : 'Quick Add Work Order'}
      onClose={handleClose}
    >
      <QuickAddEditWork
        close={handleClose}
        data={data}
        manufactureOrderFormik={manufactureOrderFormik}
        workOrderID={value}
      />
    </SidePanel>
  )
}

export default QuickAddEditWorkOrder
